module.exports = __webpack_public_path__ + "static/media/collagen360ºIntensiveCream.6a8aaace.png";